import { Card } from '@uhg-abyss/web/ui/Card';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * WithCard
 *
 * Conditionally wraps the children in a Card component.
 *
 * @param props
 * @returns {React.JSX.Element|*}
 * @constructor
 */
export function WithCard(props) {
  const { backgroundColor, children, withCard } = props;

  if (withCard === false) {
    return children;
  }

  return (
    <Card className="widget-inner" css={{ backgroundColor }} size="small">
      {children}
    </Card>
  );
}

WithCard.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  withCard: PropTypes.bool,
};

WithCard.defaultProps = {
  backgroundColor: 'transparent',
  withCard: true,
};
